import React from 'react';
import { Box, useTheme } from '@mui/material';
import { CenterLayout } from '@orgnc/core/components/primitives';
import { forwardArticleRef } from '@orgnc/core/lib/themes/templates/article';
import { useSiteSpecificComponents, useTemplateQuery } from '@orgnc/core/hooks';
import postDisqusCommentsQuery from '@/lib/queries/postDisqusCommentsQuery';
import GoogleAdTag from '@/components/GoogleAdTag';
import { useAimGeneralOptions } from '@/utils/useAimGeneralOptions';
import LatestPost from '@/components/templates/Article/shared/LatestPost';
import TbArticleTemplateContent from './TbArticleTemplateContent';
import { injectAds, renderAfterContent } from './shared/articleUtils';
import usePostExtraFields from '../../../utils/usePostExtraFields';

const TbArticleTemplate = forwardArticleRef((props, ref) => {
  const theme = useTheme();
  const { themeId } = useSiteSpecificComponents();

  const { data: postDisqusCommentsData } = useTemplateQuery(
    postDisqusCommentsQuery,
    props.post
  );
  const postExtraFields = usePostExtraFields(props.post);
  const { buyingGuideSpotlightPost } = useAimGeneralOptions();

  const extendedProps = {
    ...props,
    post: injectAds(props.post),
    postExtraFields,
  };

  const disqusOptions = postDisqusCommentsData?.post?.disqusOptions;

  const afterContentSlot = (
    <>
      {buyingGuideSpotlightPost ? (
        <LatestPost post={buyingGuideSpotlightPost} />
      ) : null}
      {renderAfterContent(
        themeId,
        props.post.link || '',
        disqusOptions,
        props.post.title
      )}
    </>
  );

  return (
    <>
      <Box ref={ref} component="article">
        <CenterLayout
          maxWidth={`${theme.breakpoints.values.xl}${theme.breakpoints.unit}`}
        >
          <TbArticleTemplateContent
            {...extendedProps}
            sidebarContent={
              <GoogleAdTag
                zone="sidebar"
                sizes={[[300, 250]]}
                mapping={[
                  [
                    [1024, 768],
                    [
                      [300, 250],
                      [300, 600],
                    ],
                  ],
                ]}
              />
            }
            afterContentSlot={afterContentSlot}
          />
        </CenterLayout>
      </Box>
    </>
  );
});

export default TbArticleTemplate;
